{
  "tabs": {
    "chat": "שמועסן",
    "reminders": "ערינערונגען",
    "calendar": "קאַלענדאַר",
    "settings": "סעטטינגס"
  },
  "common": {
    "cancel": "אָפּרעכענען",
    "save": "היטן",
    "confirm": "באַשטעטיקן",
    "delete": "אויסמעקן",
    "back": "צוריק",
    "close": "שליסן",
    "edit": "רעדאַגירן",
    "search": "זוכן",
    "all": "אַלע",
    "loading": "לאָדן...",
    "error": "עטwas איז נישט גוט",
    "notFound": "ניט געפֿונען",
    "tryAgain": "ביטע פּרוּוו ווידער",
    "retry": "פּרוּוו ווידער",
    "undo": "אומקערן",
    "pullToRefresh": "ציען צו ריפרישן",
    "justNow": "גאַנץ לעצטנס"
  },
  "auth": {
    "welcome": "ברוכים הבאים צו FishMemory",
    "tagline": "דיין WhatsApp ערינערונג אַסיסטענט, איצט אין דיין טאַש.",
    "subtitle": "דיין WhatsApp ערינערונג אַסיסטענט, איצט אין דיין טאַש.",
    "phoneLabel": "דיין WhatsApp נומער",
    "phoneHint": "מיר שיקן אַ באַשטעטיקונג קאָד דורך WhatsApp",
    "invalidPhone": "ביטע אַרייַן אַ גילטיקער טעלעפאָן נומער",
    "continue": "ווייטער",
    "enterPhone": "אַרייַן דיין WhatsApp נומער",
    "phonePlaceholder": "טעלעפאָן נומער",
    "sendCode": "שיקן קאָד",
    "verifyTitle": "באַשטעטיקן דיין נומער",
    "otpSentTo": "אַ 6-ציפֿערן קאָד איז געשיקט צו {{phone}} דורך WhatsApp",
    "enterFullCode": "ביטע אַרייַן אַלע 6 ציפֿערן",
    "invalidOtp": "אומגעליטיקער קאָד. ביטע פּרוּוו ווידער.",
    "otpFailed": "קאָד שיקן איז נישט מצליח. פּרוּוו ווידער.",
    "otpResent": "קאָד ווידער געשיקט",
    "resendIn": "שיקן ווידער אין {{seconds}} ס",
    "resendCode": "שיקן ווידער קאָד",
    "enterOtp": "אַרייַן דעם קאָד געשיקט צו דיין WhatsApp",
    "verify": "באַשטעטיקן",
    "resend": "שיקן ווידער קאָד",
    "wrongNumber": "פֿאַלש נומער?",
    "backToPhone": "צוריק צו טעלעפאָן",
    "editPhone": "רעדאַגירן טעלעפאָן נומער",
    "error": "טעות",
    "setupTitle": "לאמיר שטעלן אַרויף",
    "setupSubtitle": "איר קענט שטענדיק טוישן די שפּעטער אין סעטטינגס",
    "namePlaceholder": "דיין נאָמען",
    "letsGo": "סוף שטעלן אַרויף",
    "skipForNow": "באַזייַטיקן פֿאַר איצט"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "שרייב אַ באַשרייַבונג...",
    "inputPlaceholder": "שרייב אַ באַשרייַבונג...",
    "typing": "FishMemory שרייבט...",
    "online": "אָנליין",
    "connecting": "פֿאַרבינדונג...",
    "reconnecting": "פֿאַרבינדונג ווידער...",
    "offline": "אָפֿליין",
    "empty": "סטאַרט אַ שמועס",
    "emptyHint": "שאַפֿן ערינערונגען, קאָנטראָליר דיין פּלאַן, אָדער בעט הילף.",
    "emptyAction": "שיקן אַ מוסטער ערינערונג",
    "actions": "שמועס אַקציעס",
    "keep": "האַלטן מעסידזשעס",
    "clearTitle": "ריין שמועס",
    "clearConfirm": "אויסמעקן אַלע מעסידזשעס פֿון דעם דעוויס? דאָס קען נישט אומגעקערט ווערן.",
    "clear": "ריין שמועס",
    "optionSelected": " אויסגעקליבן: {{label}}",
    "sendingSelection": "שיקן...",
    "connectionLost": "פֿאַרבינדונג ווידער..."
  },
  "reminders": {
    "title": "מיינע ערינערונגען",
    "active": "אַקטיוו",
    "today": "היינט",
    "thisWeek": "דעם וואָך",
    "history": "היסטאָריע",
    "items": "אייטעמס",
    "emptyTitle": "קיין ערינערונגען נאָך",
    "emptySubtitle": "שאַפֿן איין פֿון שמועס און עס וועט ווײַזן זיך דאָ.",
    "emptyAction": "עפֿענען שמועס",
    "filterActive": "אַקטיוו",
    "filterToday": "היינט",
    "filterWeek": "דעם וואָך",
    "filterHistory": "היסטאָריע",
    "emptyState": "קיין ערינערונגען נאָך. אָנהייבן שמועסן!",
    "swipeDone": "געטאן",
    "swipeSnooze": "שנאָר",
    "swipeDelete": "אויסמעקן",
    "search": "זוכן ערינערונגען...",
    "upcoming": "קומענדיק",
    "completed": "געענדיקט",
    "overdue": "צוטריטלעך",
    "tomorrow": "מאָרגן",
    "synced": "סינקעד {{value}}",
    "swipeHint": "שווייג אַ ערינערונג פֿאַר מער אַקציעס",
    "noResults": "קיין ערינערונגען פּאַסן צו דיין זוך",
    "noResultsHint": "פּרוּוו אַן אַנדער וואָרט אָדער ריין די זוך",
    "deleteAllFailed": "קיין הצלחה צו אויסמעקן אַלע ערינערונגען"
  },
  "calendar": {
    "title": "קאַלענדאַר",
    "today": "היינט",
    "tomorrow": "מאָרגן",
    "completed": "געטאן",
    "noEvents": "נישט געפּלאַנעט",
    "noEventsSubtitle": "קלייַבן אַ טאָג צו זען ערינערונגען און געשעענישן.",
    "googleEvent": "Google קאַלענדאַר",
    "legendActive": "אַקטיוו",
    "legendRecurring": "ווייטערגיין",
    "legendDone": "געטאן",
    "legendGoogle": "Google",
    "previousMonth": "פֿאַרגאַנגענער חודש",
    "nextMonth": "נעקסטער חודש",
    "previousYear": "פֿאַרגאַנגענער יאָר",
    "nextYear": "נעקסטער יאָר",
    "goToToday": "גיין צו היינט",
    "all": "אַלע",
    "active": "אַקטיוו",
    "done": "געטאן",
    "paused": "פּויז"
  },
  "settings": {
    "title": "סעטטינגס",
    "profile": "פּראָפיל",
    "name": "וויזשאַוואַל נאָמען",
    "enterName": "אַרייַן דיין נאָמען",
    "language": "שפּראַך",
    "uiLanguage": "אַפּ שפּראַך",
    "uiLanguageHelp": "טוישט די אַפּ UI, קאַלענדאַר לייבאַלס, און לייענונג אויף דעם דעוויס בלויז.",
    "serverLanguage": "שמועס שפּראַך",
    "serverLanguageHelp": "טוישט די שפּראַך וואָס דער סערווער ניצט פֿאַר ענטפֿערס און ערינערונג מעסידזשעס.",
    "timezone": "צייט זאָנע",
    "currentTimezone": "איצטיקע צייט זאָנע",
    "timezoneHelp": "אַלע ערינערונג צייטן ווערן געוויזן מיט דער צייט זאָנע.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "היט צייט זאָנע",
    "timezoneSaved": "צייט זאָנע דערהייַנטיקט",
    "detect": "דעטעקט",
    "detectFailed": "קען נישט געפֿינען צייט זאָנע",
    "autoDetect": "אויטאָמאַטיש פֿון GPS",
    "notifications": "נאָטיפיקאַציעס",
    "notificationsHelp": "פֿאָלגנדיקע ערינערונגען קאָנטראָלירן ווידערכאַפּונגען נאָך אַ ערינערונג איז געשיקט. דעוויס-לעוועל נאָטיפיקאַציעס ווערן נאָך געמאַנאַדזשד אין טעלעפאָן סעטטינגס.",
    "pushEnabled": "פּוש נאָטיפיקאַציעס",
    "autoDoneOnFire": "אויטאָמאַטיש מאַרקירן געטאן ווען געשיקט",
    "autoDoneOnFireDesc": "ווען אויס, בלייבן ערינערונגען אַקטיוו ביז דו מאַרקירסט זיי.",
    "googleCalendar": "Google קאַלענדאַר",
    "google": "Google קאַלענדאַר",
    "googleConnected": "פֿאַרבונדן",
    "googleDisconnected": "ניט פֿאַרבונדן",
    "googleConnectedHelp": "נייע ערינערונגען קענען ווערן סינקעד צו דיין קאַלענדאַר אַוטאָמאַטיש.",
    "googleDisconnectedHelp": "פֿאַרבינדן Google קאַלענדאַר צו האַלטן ערינערונגען און געשעענישן צונויפֿגעשטעלט.",
    "googleConnectFailed": "קאָנעקציע צו Google קאַלענדאַר איז נישט מצליח",
    "connected": "פֿאַרבונדן",
    "disconnected": "ניט פֿאַרבונדן",
    "connect": "פֿאַרבינדן",
    "disconnect": "אָפּשניידן",
    "autoSync": "אויטאָסינק נייע ערינערונגען",
    "autosync": "אויטאָסינק נייע ערינערונגען",
    "subscription": "אַבאָנעמענט",
    "trialUsed": "פּרובירן: {{used}}/{{total}} געניצט",
    "trialStatus": "פּרובירן בנימצא",
    "activeStatus": "אַקטיוו אַבאָנעמענט",
    "expiredStatus": "אַבאָנעמענט אויסגעגאַנגען",
    "unsubscribedStatus": "ניט אַבאָנירט",
    "about": "וועגן",
    "version": "ווערסיע",
    "logout": "אויסלאָגגן",
    "logoutTitle": "אויסלאָגגן",
    "logoutConfirm": "ביסטו זיכער צו אויסלאָגגן?",
    "noName": "קיין נאָמען נישט געשטעלט",
    "serverConnection": "סערווער פֿאַרבינדונג",
    "serverUrl": "סערווער URL",
    "serverEdit": "רעדאַגירן",
    "saveReconnect": "היט און פֿאַרבינד ווידער",
    "resetDefault": "צוריקשטעלן סטאַנדאַרט",
    "invalidServerUrlTitle": "אומגילטיקער סערווער URL",
    "invalidServerUrlMessage": "אַרייַן אַ גילטיקער http אָדער https סערווער URL, למשל https://example.com",
    "uiLanguageChangeFailed": "קיין הצלחה צו טוישן אַפּ שפּראַך. ביטע פּרוּוו ווידער.",
    "serverLanguageChangeFailed": "קיין הצלחה צו טוישן שמועס שפּראַך. ביטע פּרוּוו ווידער.",
    "timezoneChangeFailed": "קיין הצלחה צו טוישן צייט זאָנע. ביטע פּרוּוו ווידער.",
    "autoSyncChangeFailed": "קיין הצלחה צו דערהייַנטיקן אוטאָסינק. ביטע פּרוּוו ווידער.",
    "nameChangeFailed": "קיין הצלחה צו דערהייַנטיקן וויזשאַוואַל נאָמען. ביטע פּרוּוו ווידער.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ערינערונג דעטאַילס",
    "editTime": "רעדאַגירן צייט",
    "rename": "נאָמען טוישן",
    "snooze": "שנאָר",
    "snooze15": "שנאָר 15 מינוט",
    "pause": "פּויז",
    "pauseReminder": "שטעלן ערינערונג אויף פּויז",
    "resume": "ווייטערפירן",
    "resumeReminder": "ווייטערפירן ערינערונג",
    "skip": "שפּרינגען ווייַטער",
    "skipOccurrence": "שפּרינגען דעם מאָל",
    "syncGoogle": "סינק צו Google",
    "delete": "אויסמעקן",
    "deleteTitle": "אויסמעקן ערינערונג",
    "deleteConfirm": "די ערינערונג וועט ווערן פּערמאַנענט אויסגעמעקט.",
    "deleteRecurringTitle": "אויסמעקן ווייטערגייענדיקע ערינערונג",
    "deleteRecurringMessage": "ווילסטו שפּרינגען דעם מאָל אָדער אויסמעקן די גאנצע סעריע?",
    "deleteThisOccurrence": "שפּרינגען דעם מאָל",
    "deleteEntireSeries": "אויסמעקן גאנצע סעריע",
    "done": "געטאן",
    "markDone": "מאַרקירן ווי געטאן",
    "undo": "צוריקשטעלן",
    "undoPrompt": "באַדערפֿט עס ווידער אַקטיוו? שטעלן עס איצט צוריק.",
    "recurring": "ווייטערגייענדיק",
    "nextRun": "נעקסטער לויפן",
    "oneTime": "איינמאָליק",
    "pending": "וואַרטנדיק",
    "sent": "געשיקט",
    "paused": "אָפּגעשטעלט",
    "active": "אַקטיוו",
    "snoozed": "שנאָרד",
    "localTime": "געוויזן אין דיין אָרטיקע צייט",
    "recurrence": "ווייטערגיין",
    "created": "געשאַפן",
    "tags": "טאַגס",
    "fireCount": "מאָל געשיקט",
    "actions": "אַקציעס",
    "none": "קיין",
    "snoozeFailed": "קיין הצלחה צו שנאָרן ערינערונג",
    "pauseFailed": "קיין הצלחה צו שטעלן ערינערונג אויף פּויז",
    "resumeFailed": "קיין הצלחה צו ווייטערפירן ערינערונג",
    "skipFailed": "קיין הצלחה צו שפּרינגען ערינערונג",
    "doneFailed": "קיין הצלחה צו מאַרקירן ערינערונג ווי געטאן",
    "undoFailed": "קיין הצלחה צו צוריקשטעלן ערינערונג סטאַטוס",
    "deleteFailed": "קיין הצלחה צו אויסמעקן ערינערונג",
    "rescheduleTitle": "נאָכאַמאָל פּלאַנירן?",
    "rescheduleMsg": "די ערינערונג איז איבערגעדרייט. ווילסטו עס ווידער פּלאַנירן?",
    "reschedule15": "אין 15 מינוט",
    "reschedule60": "אין 1 שעה",
    "keepOverdue": "האַלטן ווי עס איז"
  },
  "onboarding": {
    "slide1Title": "ברוכים הבאים צו FishMemory",
    "slide1Sub": "דיין פּערזענלעך ערינערונג אַסיסטענט — געשטיצט דורך WhatsApp און געבויט פֿאַר דיין טאַש.",
    "slide2Title": "שמועסן נאָרמאַל",
    "slide2Sub": "שרייב ערינערונגען ווי דו דענקסט: \"ערינער מיר צו רופן מאַמע מאָרגן ביים 3 נאכמיטאָג\" — מיר טאָן די רוען.",
    "slide3Title": "קיינמאָל פאַרפירן",
    "slide3Sub": "קריג צייטלעכע נאָטיפיקאַציעס, אָרגאַניזירן מיט טאַגס, און בלייַבן אויף אַלע וואָס זאָל.",
    "getStarted": "אָנהייבן",
    "next": "ווייטער",
    "firstReminderTitle": "שאַפֿן דיין ערשטער ערינערונג!",
    "firstReminderHint": "פּרוּוו שרייבן עפּעס ווי:",
    "firstReminderExample": "ערינער מיר צו טרינקען וואַסער מאָרגן ביים 9 אַמ",
    "gotIt": "האָב עס!",
    "notifRationaleTitle": "בלייַב אויף צייט",
    "notifRationaleBody": "FishMemory דאַרף נאָטיפיקאַציעס צו דערמאָנען דיר אויף צייט. דו וועסט באַקומען אַלאַרמס בלויז פֿאַר ערינערונגען וואָס דו שאַפסט.",
    "notifRationaleAllow": "אפשר נאָטיפיקאַציעס",
    "notifRationaleLater": "אולי שפּעטער",
    "swipeHint": "שווייג רעכט פֿאַר שנעל אַקציעס →",
    "calendarDragHint": "ציען צו ווײַטער ↕"
  }
}
